const MetaTagContents = {
  LANDING_PAGE: {
    title: "ALL3D",
    name: "description",
    content:
      "ALL3D provides services and solutions for you to create, customize, distribute and monetize your 3D models, virtual showrooms and photography for valuable experiences such as ecommerce and advertising across any device.",
  },

  HOW_ALL3D_WORKS: {
    title: "How ALL3D works",
    name: "description",
    content:
      "How to create 3D visual experiences using product models, rooms, virtual studios, interior design services and request lifestyle or 3D product photography.",
  },

  CONTACT_US_FORM: {
    title: "ALL3D - Contact Us",
    name: "description",
    content:
      "Reach out to the ALL3D team to discuss customized pricing plans or get access to try out 3D photography and modelling services.",
  },

  STORE: {
    title: "ALL3D - Buy 3D Models",
    name: "description",
    content: "Buy or find free 3D product and room models and designed scenes.",
  },

  SUBSCRIPTION_PLANS: {
    title: "ALL3D - Pricing Plans and Subscriptions",
    name: "description",
    content:
      "Check out our transparent and value-driven pricing and subscription plans for 3D modelling, photography and design services including free plans.",
  },

  UNIT_PRICE: {
    title: "Detailed Pricing for 3D Photography and Design Services",
    name: "description",
    content:
      "Prices and costs for product and room models, 3D photography, lifestyle photography and design services.",
  },

  SCENE_DETAILS: {
    title: "Buy Interior Design Spaces",
    name: "description",
    content:
      "Purchase ready made designed rooms in 3D for use in real estate staging or interior design.",
  },

  SPACE_DETAILS: {
    title: "Buy 3D Room Models",
    name: "description",
    content:
      "Purchase ready made 3D room models for use in photography or your interior designs.",
  },

  FAQS: {
    title: "ALL3D - FAQs",
    name: "description",
    content:
      "Information on changing or cancelling subscription plans for 3D services",
  },

  ABOUT_US: {
    title: "ALL3D - About Us",
    name: "description",
    content:
      "We are a global team of innovators who believe that our physical world is about to be digitized in three dimensions and are working on a cutting-edge platform to facilitate mass adoption of 3D by helping companies with affordable and quick 3D photography and design services.",
  },

  PRIVACY_AND_TERMS: {
    title: "Terms of Use",
    name: "description",
    content:
      "Usage policies for 3D models, photography and virtual showroom services.",
  },

  PRODUCT_DETAILS: {
    title: "Buy 3D Product Models",
    name: "description",
    content:
      "Purchase ready made 3D product models for use in photography or your interior designs.",
  },

  SKYLINE_BOHO_RENDERS: {
    title: "ALL3D - Skyline Modern Boho Renders",
    name: "description",
    content: "Skyline Modern Boho Renders",
  },

  SKYLINE_DECO_RENDERS: {
    title: "ALL3D - Skyline Deco Glam Renders",
    name: "description",
    content: "Skyline Deco Glam Renders",
  },

  PREPPY_RENDERS: {
    title: "ALL3D - Preppy Traditional Renders",
    name: "description",
    content: "Preppy Traditional Renders",
  },

  FARMHOUSE_RENDERS: {
    title: "ALL3D - Farmhouse Renders",
    name: "description",
    content: "Farmhouse Renders",
  },

  PRIVACY: {
    title: "ALL3D - Privacy",
    name: "description",
    content: "Check our Privacy Policy.",
  },

  TERMS: {
    title: "ALL3D - Terms",
    name: "description",
    content: "Check our terms.",
  },

  PRICING_PAGE: {
    title: "ALL3D - Pricing",
    name: "description",
    content:
      "We believe in transparency and a disruptive pricing model when it comes to 3D modeling and services. Check our pricing.",
  },

  ABOUT_US_INDEX: {
    title: "ALL3D - About Us",
    name: "description",
    content:
      "We are a team of innovators who believe that our physical world is about to be digitized in three dimensions. Advances in technology will soon make our products, spaces and eventually our digital avatars widely available in digital 3D form. We want to facilitate the mass-market adoption of 3D ecommerce. We provide technology to help companies large and small create 3D digital content that builds brands, allows the creation of immersive marketing media and increases sales conversion.",
  },

  LIFESTYLES_FEED: {
    title: "ALL3D - Lifestyles Feed",
    name: "robots",
    content: "noindex",
  },
};

export default MetaTagContents;
